import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { Observable, throwError } from "rxjs";
import { tap, catchError } from "rxjs/operators";

import { UiService } from '@services/ui.service';
import { GroupingService } from '@services/grouping.service';
import { Grouping } from '@classes/grouping/grouping';
import { GroupingLists } from '@classes/grouping/grouping-lists';

@Injectable()
export class ReportCompareResolver implements Resolve<GroupingLists> {
    constructor(
        private groupingSrv: GroupingService,
        private uiSrv: UiService,
        private router: Router
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<GroupingLists> {
        this.uiSrv.routeLoadingStateChanged.next(true);

        return this.groupingSrv.getList()
        .pipe(
            tap(() => {
                this.uiSrv.routeLoadingStateChanged.next(false);
            }),
            catchError((error) => {
                this.uiSrv.routeLoadingStateChanged.next(false);
                this.router.navigate(['/']);
                return throwError(error);
            })
        );
    }
}
